import { render, staticRenderFns } from "./itemTwoUploader.vue?vue&type=template&id=2b333f12"
import script from "./itemTwoUploader.vue?vue&type=script&lang=ts"
export * from "./itemTwoUploader.vue?vue&type=script&lang=ts"
import style0 from "./itemTwoUploader.vue?vue&type=style&index=0&id=2b333f12&prod&lang=less"
import style1 from "./itemTwoUploader.vue?vue&type=style&index=1&id=2b333f12&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports